import React, { useState } from "react";
import {
  Button,
  TextField,
  Typography,
  Paper,
  Box,
  Divider,
  InputAdornment,
  FormControlLabel,
  Checkbox,
  Link,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import bank from "../../assets/images/bankmudraa_logonew.png";

const LoginForm = () => {
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");

  return (
    <Paper
      elevation={0}
      sx={{
        p: 4,
        width: "100%", // 🔑 prevents inner box edge
        maxWidth: 380, // keeps same visual size
        mx: "auto",
        height: "100%",
        borderRadius: "inherit", // 🔑 blends with parent card
        bgcolor: "#16223f",
        color: "#ffffff",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      {/* LOGO */}
      <Box
        sx={{
          width: 200,
          height: 56,
          mx: "auto",
          mb: 2,
          borderRadius: "50%",
          //   bgcolor: "rgba(77, 171, 247, 0.15)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          component="img"
          src={bank}
          alt="Login"
          sx={{
            width: "100%",
            height: "100%",
            bgcolor: "#fff",
            padding: "8px",
            borderRadius: "8px",
          }}
        />
      </Box>

      {/* HEADING */}
      <Typography
        variant="h5"
        textAlign="center"
        fontWeight={600}
        color="#ffffff"
      >
        Login Account
      </Typography>

      <Typography
        variant="body2"
        textAlign="center"
        sx={{ color: "rgba(255,255,255,0.65)", mb: 3 }}
      >
        Enter your credentials to continue
      </Typography>

      {/* EMAIL */}
      <TextField
        fullWidth
        label="Mobile Number"
        margin="normal"
        value={mobile}
        onChange={(e) => {
          const value = e.target.value.replace(/\D/g, ""); // allow only digits
          if (value.length <= 10) {
            setMobile(value);
          }
        }}
        InputLabelProps={{
          style: { color: "rgba(255,255,255,0.7)" },
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <PhoneIphoneIcon sx={{ color: "#4dabf7" }} />
              <span style={{ color: "#4dabf7", marginRight: 8 }}>+91</span>
            </InputAdornment>
          ),
          style: { color: "#ffffff" },
          inputMode: "numeric",
        }}
        placeholder="Enter 10-digit mobile number"
        sx={inputStyle}
      />

      {/* PASSWORD */}
      <TextField
        fullWidth
        label="Password"
        type="password"
        margin="normal"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        InputLabelProps={{
          style: { color: "rgba(255,255,255,0.7)" },
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <LockOutlinedIcon sx={{ color: "#4dabf7" }} />
            </InputAdornment>
          ),
          style: { color: "#ffffff" },
        }}
        sx={inputStyle}
      />

      {/* REMEMBER + FORGOT */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mt: 2,
        }}
      >
        <FormControlLabel
          control={
            <Checkbox
              sx={{
                color: "#4dabf7",
                "&.Mui-checked": { color: "#4dabf7" },
              }}
            />
          }
          label={
            <Typography variant="body2" sx={{ color: "#c7d2fe" }}>
              Remember me
            </Typography>
          }
        />

        <Link
          href="#"
          underline="hover"
          sx={{
            color: "#4dabf7",
            fontWeight: 600,
            fontSize: "0.9rem",
          }}
        >
          Forgot Password?
        </Link>
      </Box>

      {/* LOGIN BUTTON */}
      <Button
        fullWidth
        variant="contained"
        sx={{
          mt: 3,
          py: 1.4,
          fontWeight: 700,
          textTransform: "none",
          borderRadius: 2,
          background: "linear-gradient(90deg, #1976d2, #4dabf7)",
          boxShadow: "0 10px 28px rgba(25,118,210,0.45)",
          "&:hover": {
            background: "linear-gradient(90deg, #1565c0, #2196f3)",
          },
        }}
      >
        Sign In Securely →
      </Button>

      <Divider sx={{ my: 3, borderColor: "rgba(255,255,255,0.12)" }} />

      <Typography
        variant="body2"
        textAlign="center"
        sx={{ color: "rgba(255,255,255,0.6)" }}
      >
        © 2025 Secure Login Portal
      </Typography>
    </Paper>
  );
};

export default LoginForm;

/* ---------------- INPUT STYLE ---------------- */

const inputStyle = {
  "& .MuiOutlinedInput-root": {
    borderRadius: 2,
    bgcolor: "rgba(255,255,255,0.04)",
    "& fieldset": {
      borderColor: "rgba(255,255,255,0.3)",
    },
    "&:hover fieldset": {
      borderColor: "#4dabf7",
    },
  },
};
